import { Button, Card, Form, Input, message } from "antd";
import {
  LockOutlined,
  MailOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { FcGoogle } from "react-icons/fc";
import { BsTwitterX } from "react-icons/bs";
import { FaFacebookF, FaApple } from "react-icons/fa";
import "./SignUp.scss";
import { mixPostV1 } from "services/mixin";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "lucide-react";
import { Typography } from "antd";
import { Flex } from 'antd';
import type { GetProps } from 'antd';
import { GoogleLogin } from '../Login/LoginByGG';

dayjs.extend(customParseFormat);
type OTPProps = GetProps<typeof Input.OTP>;

interface FormSignUpProp {
  setActiveIndex: (x: number) => void;
  setRegisSuccess: (x: number) => void;
  regisSuccess: number;
}

function FormSignUp(props: FormSignUpProp) {
  const invitation_token = new URLSearchParams(window.location.search).get('invitation_token') ?? '';
  const [form] = Form.useForm();
  const { setActiveIndex, regisSuccess, setRegisSuccess } = props;
  const [password, setPassword] = useState("");
  const [showPasswordStrength, setShowPasswordStrength] = useState(false);
  const [loading, setLoading] = useState(false);
  const [referralCode, setReferralCode] = useState<string>("");
  const [isReferralCodeReadOnly, setIsReferralCodeReadOnly] = useState<boolean>(false);
  const [mail, setMail] = useState<string>("");
  const [uid, setUid] = useState<string | null>(null);
  const [otpValue, setOtpValue] = useState('');
  const [reactive, setReactive] = useState<string | null>(null);
  const [signupState, setSignupState] = useState<"signup" | "otp" | "profile">("signup");

  async function verifyOtp(otp: string, uid: string | null, values: { email: string; password: string }) {
    try {
      if (!uid) {
        message.error('User ID is missing!');
        return;
      }
      if (otp.length !== 6) {
        message.error('Please enter a valid 6-digit OTP code!');
        return;
      }
      if (!reactive) {
        const res = await mixPostV1('/api/v1/verify-email-otp', {
          user_id: uid,
          otp: otp
        });

        if (res.status) {
          message.success('OTP verified successfully!');
          navigate('/sign-up/step');
        } else {
          //setSignupState("otp");
          message.error(res.message || 'OTP verification failed, please try again!');
          return;
        }
      }
      else {
        const res = await mixPostV1('/api/v1/complete-verification', {
          user_id: uid,
          otp: otp
        });
        if (res.status) {
          message.success('OTP verified successfully!');
          navigate('/login');
        } else {
          message.error(res.message || 'OTP verification failed, please try again!');
        }
      }
      // auto login
      try {
        const loginRes = await mixPostV1("/api/v1/be/login", {
          email: values.email,
          password: values.password,
        });
        if (loginRes.status) {
          localStorage.setItem('token', loginRes.data.access_token);
          localStorage.setItem('user', JSON.stringify(loginRes.data.info));

          localStorage.setItem(
            "registrationData",
            JSON.stringify({
              email: values.email,
              registeredAt: new Date().toISOString(),
            })
          );

          message.success("Registration successful! Please complete your profile.");
          navigate('/sign-up/step');
        } else {
          message.error(loginRes.message || "Login failed!");
          setActiveIndex(0);
        }
      } catch (error) {
        message.error("Login failed!");
        setActiveIndex(0);
      }
      setRegisSuccess(regisSuccess + 1);
    }
    catch (error) {
      message.error('OTP verification failed, please try again!');
    }
  }


  async function resendOtp(uid: string | null) {
    try {
      if (!uid) {
        message.error('User ID is missing!');
        return;
      }
      const res = await mixPostV1('/api/v1/resend-verification-otp', {
        user_id: uid,
      });
      if (res.status) {
        message.success('OTP resent successfully! Please check your email.');
      } else {
        message.error(res.message || 'Failed to resend OTP, please try again!');
      }
    }
    catch (error) {
      message.error('Failed to resend OTP, please try again!');
    }
  }

  useEffect(() => {
    if (otpValue.length === 6) {
      verifyOtp(otpValue, uid, { email: mail, password: password });
    }
  }, [otpValue]);

  const onChange: OTPProps['onChange'] = async (text) => {
    setOtpValue(text);
  };

  const onInput: OTPProps['onInput'] = (value) => {
    // change every input
  };

  const sharedProps: OTPProps = {
    onChange,
    onInput,
  };

  const handleLoginGoogle = async () => {
    // logic login here
    return;
  };
  const handleLoginFacebook = async () => {
    // logic login here
    return;
  };
  const handleLoginTwitter = async () => {
    // logic login here
    return;
  };
  const handleLoginApple = async () => {
    // logic login here
    return;
  };

  const navigate = useNavigate();
  const location = useLocation();

  // Lấy referral_code từ URL
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const referralCodeFromUrl = searchParams.get("referral_code");
    if (referralCodeFromUrl) {
      setReferralCode(referralCodeFromUrl);
      setIsReferralCodeReadOnly(true);
      form.setFieldsValue({ referral_code: referralCodeFromUrl });
    }
  }, [location.search, form]);

  const onFinish = async (values: any) => {
    setLoading(true);
    function formatDate(dateString: string) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Tháng bắt đầu từ 0
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }


    const params = {
      email: values.email,
      password: values.password,
      password_confirmation: values.password_confirmation,
      referral_code: values.referral_code || "",
      invitation_token: invitation_token || "",
      //   fullname: `${values.firstName} ${values.lastName}`,
      //   phone: values.phone,
      //   birthday: values.birthday ? formatDate(values.birthday.$d) : "",
      //   first_name: values.firstName,
      //   last_name: values.lastName,
    };

    try {
      const res = await mixPostV1("/api/v1/sign-up", params);
      setMail(values.email);

      if (res.status) {
        setUid(res.data.user.id);
        message.success("Registration successful! Please check your email for the OTP code.");
        setSignupState("otp");

      } else {
        const errors = res.errors
        const allErrors = Object.values(errors).flat();
        allErrors.forEach((err: any) => {
          message.error(err);
        });
      }
    } catch (error) {
      message.error("Registration failed!");

    } finally {
      setLoading(false);
    }
  };

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setPassword(value);
    setShowPasswordStrength(value.length > 0);
  };

  //   function setShowPopup(arg0: boolean): void {
  //     throw new Error("Function not implemented.");
  //   }

  if (signupState === "signup") {
    return (
      <Card className="card-custom !p-4 !bg-transparent !bg-white/5 !backdrop-blur-lg !border !border-white/30 !shadow-2xl !flex-1">
        <Typography.Title level={2} className="text-center !text-3xl text-white !mb-8">
          Register
        </Typography.Title>
        <div className='form'>
          <div className="form-signup">
            <Form
              form={form}
              name="login_form"
              onFinish={onFinish}
              layout="vertical"
              size="large"
              initialValues={{ remember: true }}
            >
              <Form.Item
                name="email"
                rules={[
                  { required: true, message: "Email is required!" },
                  { type: "email", message: "Email invalid! (ex: abc@xyz.com)" },
                ]}
              >
                <Input
                  prefix={<MailOutlined className="text-white" />}
                  placeholder="Enter your Email"
                  className="custom-input !rounded-full !bg-transparent !text-white"
                />
              </Form.Item>
              <Form.Item
                name="password"
                rules={[
                  { required: true, message: "Password is required!" },
                  { min: 8, message: "Password must be at least 8 characters!" },
                ]}
                className="password-field-container"
              >
                <Input.Password
                  // prefix={<UserOutlined className="text-white" />}
                  prefix={<LockOutlined className="text-white" />}
                  placeholder="Enter your password"
                  className="custom-input !rounded-full !bg-transparent !text-white"
                  onChange={handlePasswordChange}
                  onFocus={() => setShowPasswordStrength(password.length > 0)}
                  onBlur={() => setTimeout(() => setShowPasswordStrength(false), 200)}
                />
              </Form.Item>

              <Form.Item
                name="password_confirmation"
                rules={[
                  { required: true, message: "Confirm Password is required!" },
                  { min: 8, message: "Password must be at least 8 characters!" },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error("Passwords do not match!"));
                    },
                  }),
                ]}
              >
                <Input.Password
                  // prefix={<UserOutlined className="text-white" />}
                  prefix={<LockOutlined className="text-white" />}
                  placeholder="Enter your confirm password"
                  className="custom-input !rounded-full !bg-transparent !text-white"
                />
              </Form.Item>
              <Form.Item
                name="referral_code"
                rules={[
                  { required: false },
                  { pattern: /^[A-Z0-9]{8}$/, message: "Referral code must be 8 alphanumeric characters!" },
                ]}
              >
                <Input
                  prefix={<Link className="text-white w-5 h-5" />}
                  placeholder="Enter referral code (optional)"
                  className="custom-input !rounded-full !bg-transparent !text-white"
                  readOnly={isReferralCodeReadOnly}
                  onChange={(e) => setReferralCode(e.target.value)}
                />
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  className="btn-submit !bg-white hover:!bg-white/80 !text-black !text-[18px] !rounded-full !h-10"
                >
                  {loading ? "Registering..." : "Register"}
                </Button>
              </Form.Item>
            </Form>
            {/* <InfoPopup isOpen={showPopup} onClose={() => setShowPopup(false)} /> */}
            <div className="flex items-center mb-4">
              <div className="flex-grow border-t border-gray-300"></div>
              <span className="mx-2 text-white text-sm">or</span>
              <div className="flex-grow border-t border-gray-300"></div>
            </div>
            <div className="flex flex-col md:flex-row gap-2 mb-2">
              {/* <button
                type="button"
                onClick={handleLoginGoogle}
                className="w-full min-w-[240px] bg-[#e5e5e5] !text-[#000000] !text-[15px] py-2 px-4 !rounded-sm hover:!bg-white/60 transition duration-300 flex items-center justify-center gap-2"
              >
                <FcGoogle className="w-5 h-5" />
                Continue with Google
              </button> */}
              <GoogleLogin />
              <button
                type="button"
                onClick={handleLoginTwitter}
                className="w-full min-w-[240px] bg-[#e5e5e5] !text-[#000000] !text-[15px] py-2 px-4 !rounded-sm hover:!bg-white/60 transition duration-300 flex items-center justify-center gap-2"
              >
                <BsTwitterX className="w-5 h-5" />
                Continue with X
              </button>
            </div>

            <div className="flex flex-col md:flex-row gap-2 mb-4">
              <button
                type="button"
                onClick={handleLoginFacebook}
                className="w-full min-w-[240px] bg-[#e5e5e5] !text-[#000000] !text-[15px] py-2 px-4 !rounded-sm hover:!bg-white/60 transition duration-300 flex items-center justify-center gap-2"
              >
                <FaFacebookF className="w-4 h-4 text-blue-600" />
                Continue with Meta
              </button>
              <button
                type="button"
                onClick={handleLoginApple}
                className="w-full min-w-[240px] bg-[#e5e5e5] !text-[#000000] !text-[15px] py-2 px-4 !rounded-sm hover:!bg-white/60 transition duration-300 flex items-center justify-center gap-2"
              >
                <FaApple className="w-5 h-5" />
                Continue with Apple
              </button>
            </div>
          </div>
        </div>
        <div className='flex gap-2 items-center justify-center text-white/90 mt-6'>
          <p>Already have an account?</p>
          <p className='text-white font-bold cursor-pointer hover:text-white/80 transition-colors duration-200' onClick={() => setActiveIndex(0)}>Login</p>
        </div>

        <Form.Item
          name="agreement"
          valuePropName="checked"
          rules={[
            {
              validator: (_, value) =>
                value
                  ? Promise.resolve()
                  : Promise.reject(new Error("You must agree to the Privacy & User Agreement")),
            },
          ]}
          className="!mb-2 flex justify-center"
        >
          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              id="agreement"
              checked={form.getFieldValue("agreement")}
              onChange={e => form.setFieldsValue({ agreement: e.target.checked })}
              className="accent-primary"
            />
            <label htmlFor="agreement" className="text-white/90 text-sm select-none">
              I have read and agree to the&nbsp;
              <a
                href="/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="!text-white/90 !no-underline hover:!underline"
              >
                <span className="text-primary">Privacy</span> &amp; <span className="text-primary">User Agreement</span>
              </a>
            </label>
          </div>
        </Form.Item>
      </Card>

    );
  } else if (signupState === "otp") {
    return (
      <div className='signUp-container'>
        <div className="flex justify-between lg:max-w-4xl mx-auto">
          <div className="flex flex-col justify-center items-center card-custom !px-6 !py-4 !bg-transparent !bg-white/5 !backdrop-blur-lg !border !border-white/30 !shadow-2xl !flex-1 rounded-lg">
            <Typography.Title level={2} className="text-center !text-3xl text-white !mb-8">
              OTP Verification
            </Typography.Title>
            <div>
              <p className="text-center text-white mb-4">Please enter the OTP sent to your email.</p>
              <Flex justify="center" align="center" gap={16}>
                <Input.OTP
                  {...sharedProps}
                  value={otpValue}
                  onChange={(value) => setOtpValue(value)}
                  length={6}
                  size="large"
                  autoFocus
                />
              </Flex>
            </div>
            <div className='flex gap-2 flex-row items-center justify-center text-white/90 mt-6'>
              <p>Didn't receive the code?</p>
              <p onClick={
                () => {
                  resendOtp(uid);
                }
              } className="text-white text-decoration-underline font-bold cursor-pointer hover:text-white/80 transition-colors duration-200">
                Resend
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default FormSignUp;
